export enum MESSAGE_SEVERITY {
  error = "error",
  warning = "warning",
  info = "info",
  success = "success",
}

export const ALL = "all" as const;

export const CANCEL_TEXT = "Отменён";
export const NO_TEXT = "Нет";
export const FILE_TYPE = "file";





